import Icon from '../components/Icon.vue'

Icon.register({
  'user-edit': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H322.9C320.5 505.2 319.5 498 320.3 490.7L327.1 429.8 328.3 418.7 336.2 410.8 413.5 333.5C389 305.8 353.5 288 313.6 288zM358.9 433.3L352.1 494.3C351 504.5 359.6 513.1 369.7 511.9L430.6 505.1 568.5 367.2 496.8 295.5 358.9 433.3zM633 268.9L595.1 231C585.8 221.7 570.6 221.7 561.3 231L523.5 268.8 519.4 272.9 591.2 344.6 633 302.8C642.3 293.4 642.3 278.3 633 268.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-edit.js
// module id = o0FX
// module chunks = 144